import React from "react";
import { ToasterView } from "../models/views/profile/ToasterView";

export interface INotifyContextView {
  showNotify: (toasterView? :ToasterView) => void
}

const NotifyContext = React.createContext<INotifyContextView>({
  showNotify: () => {}
});


export default NotifyContext;
